import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@ui-kit/AlertDialog";
import { Button } from "@ui-kit/Button";
import { tui } from "../locale";
import { useWorkspaceToolsActions } from "../store/useWorkspaceToolsActions";
import { useWorkspaceToolsStore } from "../store/useWorkspaceToolsStore";

export const WorkspaceToolsReloadConfirm = () => {
	const confirm = useWorkspaceToolsStore((store) => store.reloadConfirm);
	const setConfirm = useWorkspaceToolsStore((store) => store.setReloadConfirm);
	const { reload } = useWorkspaceToolsActions();
	if (!confirm) return null;

	const { unpublished } = confirm;
	const cancel = () => setConfirm(null);

	return (
		<AlertDialog onOpenChange={(open) => !open && cancel()} open>
			<AlertDialogContent status="warning">
				<div className="contents" data-testid="workspace-tools-reload-confirm">
					<AlertDialogHeader>
						<AlertDialogTitle>{tui("reload.title")}</AlertDialogTitle>
						<AlertDialogDescription>
							{unpublished === null
								? tui("reload.description-uncounted")
								: tui("reload.description", { count: unpublished })}
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel onClick={cancel}>{tui("reload.cancel")}</AlertDialogCancel>
						<Button
							onClick={() => void reload(unpublished === null ? "unknown" : String(unpublished))}
							status="warning"
							variant="primary"
						>
							{tui("reload")}
						</Button>
					</AlertDialogFooter>
				</div>
			</AlertDialogContent>
		</AlertDialog>
	);
};
